export const classes = {
  maxHeightTrans: "transition-[max-height] duration-300 ",
};
